import type { ReactElement } from 'react';

import { Card, type IWithPopoverProps, WithPopover } from '@procurify/ui'

import {
  BudgetProgressBarTooltip,
  type IBudgetProgressBarTooltipProps,
} from './BudgetProgressBarTooltip'

export interface IWithBudgetProgressBarTooltipProps
  extends IBudgetProgressBarTooltipProps {
  disabled?: boolean
  large?: boolean
  WithPopoverProps?: Partial<Omit<IWithPopoverProps, 'ref'>>
  /*
   * children for WithPopover has to be a React.ReactElement and not React.ReactNode
   * React.ReactNode can be string or number, which cannot hold a ref
   */
  children: ReactElement
}

export const WithBudgetProgressBarTooltip = ({
  WithPopoverProps = {},
  disabled = false,
  large = false,
  isOverBudget,
  committedSpend,
  pendingRequests,
  remainingAfterPendingRequests,
  totalSpend,
  spendRequest,
  children,
}: IWithBudgetProgressBarTooltipProps) => {
  const {
    placement = 'top',
    trigger = 'hover',
    ...otherWithPopoverProps
  } = WithPopoverProps

  return (
    <WithPopover
      content={
        <Card.Content>
          <BudgetProgressBarTooltip
            isOverBudget={isOverBudget}
            committedSpend={committedSpend}
            pendingRequests={pendingRequests}
            remainingAfterPendingRequests={remainingAfterPendingRequests}
            spendRequest={spendRequest}
            totalSpend={totalSpend}
            large={large}
          />
        </Card.Content>
      }
      style={{ display: 'block' }}
      placement={placement}
      trigger={trigger}
      disableHoverListener={disabled}
      {...otherWithPopoverProps}
    >
      {children}
    </WithPopover>
  )
}
